// src/components/common/ToastContainer.js
import { useState } from 'react';

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  // Словарь переводов
  const translations = {
    'Please log in to access this page.': 'Пожалуйста, авторизуйтесь для доступа к функционалу сайта.',
    'Call analysis updated.': 'Анализ звонка обновлён.',
    'Theme saved successfully.': 'Тема сохранена.',
    'Error saving theme.': 'Ошибка при сохранении темы.',
    'Changes saved.': 'Изменения сохранены.',
    'User created successfully.': 'Пользователь успешно создан.',
    'Login successful.': 'Вход выполнен.',
    'Logged out.': 'Выход выполнен.',
    // Добавляйте сюда новые переводы
  };

  // Функция для показа тоста
  const addToast = (message) => {
    const id = Date.now() + Math.random();
    const translated = translations[message] || message;
    console.log(translated)
    setToasts((prev) => [...prev, { id, message: translated }]);

    // Автоудаление через 6 сек
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, 6000);
  };

  // Делаем доступным глобально
  window.showToast = addToast;

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="toast"
          dangerouslySetInnerHTML={{ __html: toast.message }}
          style={{
            opacity: 0,
            transform: 'translateY(20px)',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
          }}
          ref={(el) => {
            if (el) {
              requestAnimationFrame(() => {
                el.style.opacity = 1;
                el.style.transform = 'translateY(0)';
              });
            }
          }}
        />
      ))}
    </div>
  );
};

export default ToastContainer;



